<template lang="pug">
.generic-wrapper
  .container
    h1.title Einstellungen
    .sub-headline Hier finden Sie die wichtigsten Konfigurationen.

    MenuItems
      MenuItem(name="Benutzerverwaltung" 
        description="Verwalten Sie alle Nutzer der FeWo Pro Software." 
        @click="$router.push({name: 'SettingsUsers'})")
        template(v-slot:img)
          svg(xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewbox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round')
            path(d='M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2')
            circle(cx='9' cy='7' r='4')
            path(d='M23 21v-2a4 4 0 0 0-3-3.87')
            path(d='M16 3.13a4 4 0 0 1 0 7.75')
      
      MenuItem(name="PDF Dokumenteninhalte" 
        description="Verwalten Sie alle Dokumenteninhalte." 
        @click="$router.push({name: 'SettingsDocumentContents'})")
        template(v-slot:img)
          svg(xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewbox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round')
            path(d='M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z')
            polyline(points='14 2 14 8 20 8')
            line(x1='16' y1='13' x2='8' y2='13')
            line(x1='16' y1='17' x2='8' y2='17')
            polyline(points='10 9 9 9 8 9')

      MenuItem(name="E-Mail Vorlagen" 
        description="Verwalten Sie alle E-Mail Vorlagen." 
        @click="$router.push({name: 'SettingsEmailTemplates'})")
        template(v-slot:img)
          svg(xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewbox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round')
            path(d='M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z')
            polyline(points='22,6 12,13 2,6')

      MenuItem(name="Channelmanager" 
        description="Senden Sie Ihre Daten wie Belegtzeiten und Stammdaten an alle Channels." 
        @click="$router.push({name: 'SettingsChannelManager'})")
        template(v-slot:img)
          svg(xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewbox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round')
            path(d='M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z')
            polyline(points='7.5 4.21 12 6.81 16.5 4.21')
            polyline(points='7.5 19.79 7.5 14.6 3 12')
            polyline(points='21 12 16.5 14.6 16.5 19.79')
            polyline(points='3.27 6.96 12 12.01 20.73 6.96')
            line(x1='12' y1='22.08' x2='12' y2='12')

      MenuItem(name="Mietobjekttypen" 
        description="Verwalten Sie alle Mietobjekttypen wie z.B. Haupthaus, Ferienhaus, usw." 
        @click="$router.push({name: 'SettingsRentObjectTypes'})")
        template(v-slot:img)
          svg(xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewbox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round')
            rect(x='3' y='3' width='7' height='7')
            rect(x='14' y='3' width='7' height='7')
            rect(x='14' y='14' width='7' height='7')
            rect(x='3' y='14' width='7' height='7')

      MenuItem(name="Provision"
        description="Verwalten Sie Provisionseinstellungen."
        @click="$router.push({name: 'SettingsCommissions'})")
        template(v-slot:img)
          svg(xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewbox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round')
            line(x1='19' y1='5' x2='5' y2='19')
            circle(cx='6.5' cy='6.5' r='2.5')
            circle(cx='17.5' cy='17.5' r='2.5')
            
      MenuItem(name="Buchungsextras"
        description="Verwalten Sie pflicht und optional buchbare Extras." 
        @click="$router.push({name: 'SettingsBookingExtras'})")
        template(v-slot:img)
          svg(xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewbox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round')
            circle(cx='9' cy='21' r='1')
            circle(cx='20' cy='21' r='1')
            path(d='M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6')
      
      MenuItem(name="Ausstattungstypen"
        description="Hier können Sie alle möglichen Ausstattungsmerkmale pflegen." 
        @click="$router.push({name: 'SettingsFeatureTags'})")
        template(v-slot:img)
          svg(xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewbox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round')
            rect(x='3' y='3' width='7' height='7')
            rect(x='14' y='3' width='7' height='7')
            rect(x='14' y='14' width='7' height='7')
            rect(x='3' y='14' width='7' height='7')
      
      MenuItem(name="Feiertage"
        description="Verwalten Sie alle Feiertage." 
        @click="$router.push({name: 'SettingsHolidays'})")
        template(v-slot:img)
          svg(xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewbox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round')
            circle(cx='12' cy='12' r='5')
            line(x1='12' y1='1' x2='12' y2='3')
            line(x1='12' y1='21' x2='12' y2='23')
            line(x1='4.22' y1='4.22' x2='5.64' y2='5.64')
            line(x1='18.36' y1='18.36' x2='19.78' y2='19.78')
            line(x1='1' y1='12' x2='3' y2='12')
            line(x1='21' y1='12' x2='23' y2='12')
            line(x1='4.22' y1='19.78' x2='5.64' y2='18.36')
            line(x1='18.36' y1='5.64' x2='19.78' y2='4.22')

      MenuItem(name="Geschäftslogik" 
        description="Verwalten Sie die Einstellungen Ihrer Geschäftslogik." 
        @click="$router.push({name: 'SettingsBusinessLogic'})")
        template(v-slot:img)
          svg(xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewbox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round')
            rect(x='4' y='4' width='16' height='16' rx='2' ry='2')
            rect(x='9' y='9' width='6' height='6')
            line(x1='9' y1='1' x2='9' y2='4')
            line(x1='15' y1='1' x2='15' y2='4')
            line(x1='9' y1='20' x2='9' y2='23')
            line(x1='15' y1='20' x2='15' y2='23')
            line(x1='20' y1='9' x2='23' y2='9')
            line(x1='20' y1='14' x2='23' y2='14')
            line(x1='1' y1='9' x2='4' y2='9')
            line(x1='1' y1='14' x2='4' y2='14')


</template>

<script>
import MenuItem from "@/components/atoms/MenuItem.vue";
import MenuItems from "@/components/molecules/MenuItems.vue";

export default {
  components: {
    MenuItem,
    MenuItems
  },
  computed: {
    me() {
      return this.$store.state.me.me;
    }
  }
};
</script>